export default __webpack_public_path__ + "static/media/OuroPreto.edddfb00.png";